import { retrieveAllSpecialist } from "../../../redux/admin-slices/specialist.slice"
import { showDialogWithData } from "../../../redux/guest-slices/other.slice"
import TablePagination from "../../../components/common/PaginationSkell"
import EntriesSelect from "../../../components/ui/EntriesSelect"
import TableSkell from "../../../components/common/TableSkell"
import SelectInputA from "../../../components/ui/SelectInputA"
import { DISABLE_USER_STATUS } from "../../../utils/keywords"
import InputFieldA from "../../../components/ui/InputFieldA"
import SelectInput from "../../../components/ui/SelectInput"
import UserServices from "../../../services/user.service"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect, useRef } from "react"
import { debounce } from "../../../utils/helper"
import ActionMenu from "./ActionMenu"
import moment from "moment"

import {
  Avatar, Box, Chip, Container, Grid2 as Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
} from "@mui/material"

function AllSpecialists() {
  const searchRef = useRef("")
  const statusRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const [data, setData] = useState(null)
  const userServices = new UserServices(dispatch)
  const [activeIndex, setActiveIndex] = useState(null)
  const { loadings, refresh } = useSelector((state) => state.otherSlice)

  // Gandle retrieve all specialists
  const handleRetrieveAll = (filters) => {
    dispatch(
      retrieveAllSpecialist({
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data)
      })
      .catch(() => { })
  }

  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  const handleToggleActiveStatus = async (id, status) => {
    if (!status) {
      dispatch(
        showDialogWithData({
          type: DISABLE_USER_STATUS,
          data: { memberId: id, status },
        })
      )
      return
    }

    const { success } = await userServices.enableUser({ id })
    if (success) handleRetrieveAll()
  }

  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [refresh])
  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Specialists</Typography>
      </Box>

      <Grid
        container
        spacing={1}
        className="filters-grid"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            placeholder={"Search..."}
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Approval type"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="Select a value"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
            options={[
              { name: "Pending", value: "pending" },
              { name: "Verified", value: "verified" },
              { name: "Rejected", value: "rejected" },
            ]}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "Name",
                  "Email",
                  "Account Status",
                  "Date",
                  "Status",
                  "Action",
                ]?.map((cell, i) => (
                  <TableCell key={i} align="left">
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ? (
                <TableSkell colLength={6} />
              ) : (
                data?.records?.map((user, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{
                      td: {
                        borderBottomWidth:
                          i === data?.records?.length - 1 ? "0" : "1px",
                      },
                    }}
                  >
                    <TableCell sx={{ textTransform: "capitalize" }}>
                      <Box
                        gap={1}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Avatar src={user?.image} />
                        <Typography> {user?.fullName} </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{user?.email}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={user?.status}
                        color={
                          user?.status === "pending"
                            ? "warning"
                            : user?.status === "verified"
                              ? "success"
                              : user?.status === "rejected"
                                ? "error"
                                : "default"
                        }
                        sx={{
                          color: "#000000de",
                          fontFamily: "Poppins",
                          textTransform: "capitalize",
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(user?.createdAt).format("MM-DD-YYYY HH:MM:SS A")}
                    </TableCell>

                    <TableCell>
                      <SelectInputA
                        renderValueKey="name"
                        value={user?.activeStatus ?
                          { name: "Active", value: true } :
                          { name: "Blocked", value: false }
                        }
                        loading={loadings?.retrieveAll}
                        key={`${user?._id}-${user?.activeStatus}`}
                        onChange={(e) => {
                          handleToggleActiveStatus(user?._id, e?.target?.value?.value)
                        }}
                        options={[
                          { name: "Active", value: true },
                          { name: "Blocked", value: false },
                        ]}
                      />
                    </TableCell>

                    <TableCell>
                      <ActionMenu
                        index={i}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        user={user}
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}

              {!data?.records?.length && !loadings?.retrieveAll && (
                <TableRow sx={{ td: { borderBottom: "none" } }}>
                  <TableCell colSpan={5}>
                    <Typography variant="noRecords">
                      No results found!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
          cb={handleRetrieveAll}

        />
      </Box>
    </Container>
  )
}

export default AllSpecialists
